<template>
  <small class="d-block ml-4 text-muted">
    <template v-if="value === 'billing'">
      Use and manage any credit card on the account, including cards added by other users. Also add funds and make manual payments. Everyone on the account can see balances and invoices.
    </template>
    <template v-else-if="value === 'admin'">
      Add or remove users, change other users' permissions, manage API keys and account security. Includes Billing, but not <template v-if="isSellerAccount">offer access</template><template v-else>campaign access</template> or Call logs. Your own password and MFA are always available.
    </template>
    <template v-else-if="value === 'campaigns' && isSellerAccount">
      Browse and apply for offers, manage your approved offers and upload creatives. Does not include call logs or reporting.
    </template>
    <template v-else-if="value === 'campaigns'">
      Create and manage campaigns, review creatives, manage blocked channels and use softphone calling. Does not include call logs or reporting.
    </template>
    <template v-else-if="value === 'call_logs'">
      View call logs, recordings, reporting and analytics<template v-if="!isSellerAccount">, and see blocked channels</template>.
      <template v-if="isSellerAccount">
        Does not allow offer management.
      </template>
      <template v-else>
        Does not allow campaign management.
      </template>
    </template>
  </small>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AccountPermissionExplainer',

  props: {
    value: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters('auth', ['isSellerAccount'])
  }
}
</script>
